import Vue from 'vue/dist/vue.esm.js';

Vue.component('addUserAddress', {
    template: `#add-user-address`,
    delimiters: ['[[', ']]'],
    props: {
        // delivery: {
        //     required: true,
        //     type: Array,
        // },
        deliveryOptions: {
            required: true,
            type: Array,
        },
        locale: {
            required: true,
            type: String,
        },
        fetchBoxNowPlacesUrl: {
            required: true,
            type: String,
        },
        fetchSpeedyPlacesUrl: {
            required: true,
            type: String,
        },
        fetchOfficesUrl: {
            required: true,
            type: String,
        },
        hasUser: {
            required: true,
            type: Number,
        },
        userAddresses: {
            required: false,
            type: Array,
        },
        googleMapsApiKey: {
            required: true,
            type: String
        },
    },

    mounted() {
        let _self = this;
        let select2City = $(this.$refs.cityField);
        select2City.on('change', function (e) {
            _self.changeUserData();
        });

        $(document).on('select2:open', function (e) {
            document.querySelector(`[aria-controls="select2-${e.target.id}-results"]`).focus();
        });

        this.initAllowNewAddress();

        if (parseInt(this.$refs.selectedOption.dataset.val)) {
            this.selectDeliveryOption(this.deliveryOptions.filter(d => d.id === parseInt(this.$refs.selectedOption.dataset.val))[0]);
        }

        // if (parseInt(this.$refs.existingAddress.dataset.val)) {
        //     this.selectUserAddress(this.userAddresses.filter(d => d.id === parseInt(this.$refs.existingAddress.dataset.val))[0]);
        // }

        if (this.$refs.cityField && this.$refs.cityField.value) {
            this.selectedCity = this.$refs.cityField.value;
        }

        if (this.$refs.cityValue && this.$refs.cityValue.value) {
            this.selectedCity = this.$refs.cityValue.value;
        }

        EventManager.listen('order-address:city', this.cityChanged);
    },


    data() {
        return {
            // types: this.delivery,
            options: this.deliveryOptions,
            selectedType: null,
            selectedOption: null,
            selectedCity: null,
            allowNewAddress: 0,
            saveAddress: 0,
            offices: null,
            officesPage: 1,
            selectedOffice: null,
            needShowMap: false,
            placeLng: null,
            placeLat: null,
            isInitGoogleMapApiForBoxNow: false,
            isInitGoogleMapApiForSpeedyOffice: false,
            needShowMoreButton: true,
            // packages: this.packageOptions,
            quantityAlert: {
                visible: false,
                productName: '',
            },
            noOfficesWarning: false,
            errors: {
                type: false,
                option: false,
                payment: false,
                userAddress: false,
            },
        }
    },

    methods: {
        needShowMapMethod(id) {
            return this.needShowMap === id;
        },
        toggleOfficeInfo(office) {
            this.offices.forEach((item) => {
                item.active = item === office ? !item.active : false;
            });
        },
        waitFor(seconds) {
            return new Promise(resolve => {
                setTimeout(resolve, seconds * 1000); // Converts seconds to milliseconds
            });
        },
        async showMap(lat, lng, id) {
            this.needShowMap = id;
            await this.waitFor(0.1);
            GoogleApiUtility.InitMapWithMarker(lat, lng);
        },
        async selectOffice(office){
            this.selectedOffice = office;
        },
        // This function will be called by the Google Maps API callback
        async initGoogleMapsApiAutocomplete(elementId, type) {
            console.log(elementId);
            await this.waitFor(0.1);
            const input = document.getElementById(elementId);
            if (!input) {
                console.error("Input element not found");
                return;
            }

            const autocomplete = new google.maps.places.Autocomplete(input);

            // Restrict the autocomplete results to Bulgaria (BG)
            autocomplete.setComponentRestrictions({country: ['bg']});

            // Listen for the place selection
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (place.geometry) {
                    this.placeLat = place.geometry.location.lat();  // Latitude
                    this.placeLng = place.geometry.location.lng();  // Longitude

                    if (type === 'boxnow') {
                        this.fetchBoxNowPlaces(this.placeLat, this.placeLng, ++this.officesPage);
                    } else if (type === 'speedy-office') {
                        this.fetchSpeedyPlaces(this.placeLat, this.placeLng, ++this.officesPage);
                    }
                    // Call fetchBoxNowPlaces with lat and lng

                }

            });
        },
        fetchBoxNowPlaces(lat, lng, page) {
            let _self = this;
            $.ajax({
                data: {lat: lat, lng: lng, page: page},  // Pass lat and lng, not the entire geometry object
                url: _self.fetchBoxNowPlacesUrl,
                method: 'POST',
                success: function (result) {
                    _self.offices = result.results;
                    _self.officesPage = result.page;
                    _self.needShowMoreButton = result.maxResults > result.resultsPerPage * result.page;

                    // Handle result from server if necessary
                },
                error: function (error) {
                    console.error("Error fetching data:", error);
                }
            });
        },
        fetchSpeedyPlaces(lat, lng, page) {
            let _self = this;
            $.ajax({
                data: {lat: lat, lng: lng, page: page},  // Pass lat and lng, not the entire geometry object
                url: _self.fetchSpeedyPlacesUrl,
                method: 'POST',
                success: function (result) {
                    _self.offices = result.results;
                    _self.officesPage = result.page;
                    _self.needShowMoreButton = result.maxResults > result.resultsPerPage * result.page;

                    // Handle result from server if necessary
                },
                error: function (error) {
                    console.error("Error fetching data:", error);
                }
            });
        },
        getDeliveryTypeImage(option) {
            if (option.slug === 'sameday_delivery_to_locker') {
                return '/uploads/images/couriers/easybox.svg';
            }

            if (option.slug === 'glovo_on_demand') {
                return '/uploads/images/couriers/glovo.svg';
            }

            return option.courier.image ? option.courier.image : '';
        },
        initSaveAddress() {
            let value;
            if (this.validateRef("saveAddress")) {
                if (this.$refs.saveAddress.dataset.val === '') {
                    return;
                }
                if (isNaN(parseInt(this.$refs.saveAddress.dataset.val))) {
                    value = null;
                } else {
                    value = parseInt(this.$refs.saveAddress.dataset.val);
                }
            }
            this.saveAddress = value;
        },
        initAllowNewAddress() {
            let value = this.allowNewAddress;
            if (this.validateRef("allowNewAddress")) {
                if (this.$refs.allowNewAddress.dataset.val === '') {
                    return;
                }
                if (isNaN(parseInt(this.$refs.allowNewAddress.dataset.val))) {
                    value = null;
                } else {
                    value = parseInt(this.$refs.allowNewAddress.dataset.val);
                }
            }
            this.allowNewAddress = value;
        },

        validateRef(ref) {
            if (this.$refs[ref] !== undefined) {
                return true;
            }
            return false;
        },
        selectDeliveryOption(option) {
            if (this.selectedOption === option) {
                return;
            }
            this.errors.type = false;

            this.selectedOption = option;
            // this.initStep3(type);

            this.noOfficesWarning = false;
            this.selectedCity = null;
            this.selectedPaymentMethod = null;
            this.selectedCard = null;
            this.selectedType = option.deliveryType

            this.deliveryPrice = option.price;

            //hackfix for hiding select2
            if (!this.selectedType.id !== 3) {
                if (this.$refs.officeField) {
                    $(this.$refs.officeField).select2('destroy');
                }
            }

            this.offices = null;
            this.officesPage = 1;

            this.isInitGoogleMapApiForBoxNow = false;
            this.isInitGoogleMapApiForSpeedyOffice = false;

            if (this.selectedType.id === 2) {
                if (!this.isInitGoogleMapApiForBoxNow) {
                    //Load GoogleApisScript
                    GoogleApiUtility.LoadGoogleMapsScript(this.googleMapsApiKey).then(() => {
                        this.isInitGoogleMapApiForBoxNow = true;
                        this.initGoogleMapsApiAutocomplete('new_delivery_address_boxNowPlaces', 'boxnow');
                    }).catch((error) => {
                        console.error("Error loading Google Maps script:", error);
                    });
                }
            } else if (this.selectedType.id === 4) {
                if (!this.isInitGoogleMapApiForSpeedyOffice) {
                    //Load GoogleApisScript
                    GoogleApiUtility.LoadGoogleMapsScript(this.googleMapsApiKey).then(() => {
                        this.isInitGoogleMapApiForSpeedyOffice = true;
                        this.initGoogleMapsApiAutocomplete('new_delivery_address_speedyOfficePlaces', 'speedy-office');
                    }).catch((error) => {
                        console.error("Error loading Google Maps script:", error);
                    });
                }
            }

            this.needShowMap = false;
        },
        async postData(url = '', data = {}) {
            // Default options are marked with *
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json'
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(data) // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        cityChanged(data) {
            this.selectedCity = data;
            this.calcDeliveryPrice(this.deliveryPrice);
        },

        toggleNewAddressSelection() {
            this.allowNewAddress = !this.allowNewAddress & 1;
            this.selectedUserAddress = null;
            this.selectedOption = null;
            this.selectedType = null;
            // this.selectedArea = null;
            this.selectedCity = null;
        },


        preselectCity(city) {
            let select2 = $(this.$refs.cityField);
            let newOption = new Option(city.name, city.id, true, true);

            select2.append(newOption).trigger('change');
        },
        formattedDistance(distance) {
            return distance.toFixed(2) + 'КМ';
        },
        showMoreBoxNowOffices() {
            this.fetchBoxNowPlaces(this.placeLat, this.placeLng, ++this.officesPage);
        },
        showMoreSpeedyOffices() {
            this.fetchSpeedyPlaces(this.placeLat, this.placeLng, ++this.officesPage);
        },
        deliveryTypeHasDifferentPrices(type) {

            // if (type.areas.length === 1 && type.areas[0].options.length === 1) {
            //     return false;
            // }

            let price = type.options[0].price;
            let hasDifferentPrices = false;
            // type.areas.map(function (area) {
            //     area.options.map(function (option) {
            //         if (price !== option.price) {
            //             hasDifferentPrices = true;
            //         }
            //     })
            // })

            return hasDifferentPrices;

        },
        revalidate() {

            if (this.hasUser && !this.allowNewAddress && !this.selectedUserAddress) {
                this.errors.userAddress = true;
                return;
            }
            if (!this.selectedType) {
                this.errors.type = true;
                return;
            }
            if (!this.selectedOption) {
                this.errors.option = true;
                return;
            }
            if (!this.selectedPaymentMethod) {
                this.errors.payment = true;
                return;
            }
        }
        ,

        hasValidationErrors(type) {
            return this.errors[type];

        }


    },

    computed: {

    }
});